import { OnDateRangeFilter, ResetDateFilter } from '@erecruit/modules';
import { Resources } from '@erecruit/types';

import { MatchStatusColumns } from '../../../MatchSearch/columns';

export const defaultVisibleColumns = [
  nameof.full<Resources.MatchSearch>(o => o.candidate.name),
  nameof.full<Resources.MatchSearch>(o => o.status.name),
  nameof<Resources.MatchSearch>(o => o.estimatedEndDate),
  nameof<Resources.MatchSearch>(o => o.estimatedStartDate),
];

export const generateColumns = (
  filterByDate: OnDateRangeFilter,
  resetDateFilter: ResetDateFilter,
  filterState: Resources.MatchSearchFilter,
) => [
  MatchStatusColumns.getCandidateColumn(),
  MatchStatusColumns.getStatusColumn(filterState),
  MatchStatusColumns.getEstimatedEndDateColumn(
    filterState,
    resetDateFilter,
    filterByDate,
  ),
  MatchStatusColumns.getEstimatedStartDateColumn(
    filterState,
    resetDateFilter,
    filterByDate,
  ),
];
